import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginDiwali, startDiwali, submitDiwaliStage, setBasePoints } from "./diwaliSlice";
import DiwaliHeader from "./DiwaliHeader";
import "./diwali.css";

const ASSET_BASE = "/diwaliEscapeRoom";

// glowstone-old/main.php equivalent: creates/resumes the stat row, then
// shows the two intro popups (message1 -> flicker transition -> message2)
// before handing off to the escape room itself.
export default function DiwaliMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, completed, user, id: gameRowId } = useSelector((state) => state.diwali);
  const sessionId = user?.sessionId;

  const [popup, setPopup] = useState("message1_updated-min");
  const [flickering, setFlickering] = useState(false);
  const [isPortrait, setIsPortrait] = useState(
    () => window.innerHeight > window.innerWidth
  );

  useEffect(() => {
    const check = () => setIsPortrait(window.innerHeight > window.innerWidth);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // A direct visit/reload here has no session in memory — resume it first.
  useEffect(() => {
    if (!user) dispatch(loginDiwali());
  }, [user, dispatch]);

  useEffect(() => {
    // DiwaliIndex already fetched the stat row on the way here; only fetch on
    // a direct visit/reload where it's still missing.
    if (user && !gameRowId) dispatch(startDiwali());
  }, [user, gameRowId, dispatch]);

  // Already completed (a returning user, not someone who just finished) —
  // bounce out to the platform's game page instead of /diwali/thankyou,
  // which is reserved for the moment right after actually finishing (see
  // DiwaliPoker.jsx's window.send). Same destination DiwaliHeader's Back
  // button uses.
  useEffect(() => {
    if (status === "succeeded" && completed) {
      window.location.href = user?.gameId
        ? `${process.env.REACT_APP_BASE_URL}/game-detail/${user.gameId}`
        : process.env.REACT_APP_BASE_URL;
    }
  }, [status, completed, user]);

  const handleNext = useCallback(() => {
    if (popup === "message1_updated-min") {
      // Legacy main.php: flicker overlay + background swap for 4s between
      // the two popups.
      setPopup(null);
      setFlickering(true);
      setTimeout(() => {
        setFlickering(false);
        setPopup("message2_updated-min");
      }, 4000);
      return;
    }

    // Second Next: legacy seeds points=2 (a flat base, not accumulated) and
    // moves on. demobypass sessions submit round 1 immediately instead of
    // waiting for the Rangoli puzzle.
    dispatch(setBasePoints(2));
    if (sessionId === "demobypass") {
      dispatch(submitDiwaliStage({ points: 2, round: 1 }));
    }
    navigate("/diwali/game");
  }, [popup, sessionId, dispatch, navigate]);

  if (status === "loading" || status === "idle") {
    return (
      <div className="dw-main-root">
        <div className="dw-loader" />
      </div>
    );
  }

  return (
    <div
      className="dw-main-root"
      style={{
        backgroundImage: `url(${ASSET_BASE}/images/${
          flickering ? "bgwithoutglow.jpg" : isPortrait ? "mobile_main.jpg" : "background-black.jpg"
        })`,
      }}
    >
      <DiwaliHeader />
      {flickering && (
        <div
          className="dw-flicker"
          style={{ backgroundImage: `url(${ASSET_BASE}/images/Flicker-min.gif)` }}
        />
      )}

      {popup && (
        <div className="dw-popup-overlay">
          <div className="dw-popup-panel">
            <img
              src={`${ASSET_BASE}/gif/${popup}.gif`}
              alt=""
              className="dw-popup-image"
            />
            <div className="dw-popup-footer">
              <img
                src={`${ASSET_BASE}/images/nextbutton.png`}
                alt="Next"
                className="dw-next-btn"
                onClick={handleNext}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
